import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Flex, Text, Box } from 'rebass/styled-components';
import { FormInput } from '@getro/rombo';

export const SubmitButtonSection = ({ buttonText, onUpdate }) => {
  const { errors, touched, setFieldTouched } = useFormikContext();

  return (
    <Flex sx={{ flexDirection: 'column', gap: '8px', width: '100%' }}>
      <Text
        sx={{
          fontSize: '12px',
          fontWeight: '500',
          color: 'text.subtle',
          textTransform: 'uppercase',
          letterSpacing: '1px',
        }}
      >
        Submit button
      </Text>
      <Box>
        <FormInput
          label="Button text"
          placeholder="Enter button text"
          field={{
            name: 'submitButtonText',
            value: buttonText,
            onChange: (e) => onUpdate(e.target.value),
            onBlur: () => setFieldTouched('submitButtonText', true),
          }}
          form={{
            errors: { submitButtonText: errors.submitButtonText },
            touched: { submitButtonText: touched.submitButtonText },
          }}
        />
      </Box>
    </Flex>
  );
};

SubmitButtonSection.propTypes = {
  buttonText: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
};
